import { apiActions } from '../../../_core/api';
import { Middleware } from 'redux';
import { IStore } from '../../../store';
import bfl1Actions, {
	EBFL1Actions,
	EBFL1Constants,
	TBFL1Actions,
} from '../actions';
import { jobActions } from '../../../_core/job';
import { IAuthActions } from '../../auth/actions';
import { commonUtils } from '../../../_common';
import { TBFL1BackendRecord } from '../@types';
import { EMARPOLDocuments, EMARPOLModelName } from 'redux/app/marpol/@types';

const bfl1HistoryMiddleware: Middleware<{}, IStore> =
	({ dispatch, getState }) =>
		(next) =>
			(action: TBFL1Actions | IAuthActions) => {
				switch (action.type) {
					case EBFL1Actions.HISTORY_LOAD: {
						next(action);
						const job = jobActions(EBFL1Constants.FEATURE, action.type);
						const { providedFilters: filters } = action.payload;
						dispatch(bfl1Actions.document.setFilter(filters));

						dispatch(
							apiActions.apiRequest<{ logs: { docs: TBFL1BackendRecord[] } }>({
								feature: action.type,
								method: 'GET',
								url: EBFL1Constants.API,
								queryParams: {
									vesselId: filters.vesselId,
									marpolType: EMARPOLDocuments.BFL1,
									modelName: EMARPOLModelName.MARPOL,
									weekStart: filters.startDate,
									weekEnd: filters.endDate,
									state: {
										$eq: filters?.state ?? undefined
									},
									sortOrder: filters?.sortOrder ?? undefined,
								},
								preExecute() {
									dispatch(job.active({}));
								},
								postExecute: {
									onSuccess({ data }) {
										const bfl1Records = data.logs.docs.filter(
											(doc) => doc.marpolType === EMARPOLDocuments.BFL1
										);
										dispatch(
											bfl1Actions.document.historySet(
												commonUtils.arrayToObject(bfl1Records)
											)
										);
										dispatch(job.success({}));
									},
									onError() {
										dispatch(job.error({}));
									},
									finally() {
										dispatch(job.idle({}));
									},
								},
							})
						);
						break;
					}
					default: {
						next(action);
						break;
					}
				}
			};
export default bfl1HistoryMiddleware;
